import React, { useEffect, useState } from "react";
import { checkAuthentication, parseHtml } from "../../../utils/util";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Login from "../../../commons/Login";
import { Modal } from "antd";
import { showPopup } from "../../../redux/action/common";
import { fetchBlogsData } from "../../../redux/action/user/blogs";
import { getTop3Testdata, getTopVideosHome, getDashboardData } from "../../../redux/action/common-action";
import video_image_homePage from "../../../static/user/img/video_home_img.jpg";
import Hope from "../../../static/user/img/img-icons/hope.svg";
import Happiness from "../../../static/user/img/img-icons/happiness.svg";
import Health from "../../../static/user/img/img-icons/health.svg";
import Aspiration from "../../../static/user/img/img-icons/aspiration.svg";
import OfferImageThumb from "../../../static/user/img/we-offer-thumb.jpg";
import { UserRoutes } from "../../../routes";
import happyImage from "../../icons/happy_img.png";
import "./homepage.css";
import WOW from "wowjs";
import video_play_icon from "../../icons/video_play_icon.png";
import first_slide_video from "../../icons/shapes/first_slide_video.png";
import down_arrow from "../../icons/shapes/down_arrow.png";
import triangle_white_pattern from "../../icons/shapes/triangle-white-pattern.png";
import circle_white_pattern from "../../icons/shapes/circle-white-pattern.png";
import auther_name from "../../icons/auther_name.png";
import happy_mobile from "../../icons/happy_mobile.png";
import testimonial_bg from "../../icons/shapes/testimonial-bg.png";
import quote_icon from "../../icons/shapes/quote-icon.svg";
import triangle_shape from "../../icons/shapes/triangle-shape.svg";
import circle_shape from "../../icons/shapes/circle-shape.svg";
import we_offer from "../../icons/we_offer.png";
import quote_shape from "../../icons/shapes/quote.svg";
import play_icon from "../../icons/play_icon.svg";
import sach_small_white from "../../icons/sach_small_white.svg";
import we_offer_icon from "../../icons/we_offer_icon.svg";
import homeBgMobile from "../../../static/user/img/mobile_top_bg.jpg";
import TestimonialBlock from "./TestimonialBlock";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const Dashboard = (props) => {
  const { commonData, showPopup, testData, showTop3Test, getTop3Testdata, topVideos, getTopVideosHome, fetchBlogsData, blogsData, getDashboardData, dashboardData } = props;
  const [onData, setOnData] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedCategoryVideos, setSelectedCategoryVideos] = useState([]);
  const [isActiveHappiness, setIsActiveHappiness] = useState(0);
  const [TopData, setTopData] = useState([]);
  const [PhilosphyData, setPhilosphyData] = useState([]);
  const [offerData, setOfferData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [happinessData, setHappinessData] = useState([]);
  const [soluionData, setSoluionData] = useState([]);
  const [staticData, setStaticData] = useState({});
  const [videoSectionData, setVideoSectionData] = useState([]);
  const sachIcon = `<img class=${"lightIcon"} src=${require("../../../static/user/img/sach-icon.svg").default} alt="logo" /><img class=${"darkIcon"} src=${require("../../icons/sach_small_white.svg").default} alt="logo" />`;

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  useEffect(() => {
    const videosAndCategories = topVideos?.sectionData?.videoInfo;
    if (videosAndCategories) {
      setSelectedCategoryId(videosAndCategories[0]?.title);
      setSelectedCategoryVideos(videosAndCategories[0]?.cards);
    }
  }, [topVideos]);

  useEffect(() => {
    if (dashboardData && dashboardData.homePageData) {
      // console.log("dashboardData?.homePageData", dashboardData.videosSection);
      let data = dashboardData?.homePageData;
      setTopData(data?.TopData);
      setPhilosphyData(data?.PhilosphyData);
      setOfferData(data?.offerData);
      setEventData(data?.eventData);
      setHappinessData(data?.happinessData);
      setSoluionData(data?.soluionData);
      setStaticData({ ...dashboardData });
      setVideoSectionData(dashboardData.videosSection);
      localStorage.setItem("viewMoreBtn", dashboardData?.testimonialSection?.cta?.text);
    }
  }, [dashboardData]);
  const allCategories = () => {
    const videosAndCategories = topVideos?.sectionData?.videoInfo;
    const categories = [];
    for (let i = 0; i < videosAndCategories?.length; i++) {
      const catVideos = videosAndCategories[i].cards;
      let catId, subCatId;
      for (let j = 0; j < catVideos?.length; j++) {
        catId = catVideos[j].categoryId;
        subCatId = catVideos[j].subCategoryId;
      }
      categories.push({
        title: videosAndCategories[i]?.title,
        catId: catId,
        subCatId: subCatId,
      });
    }
    return categories;
  };

  useEffect(() => {
    const scrollBtn = document.getElementById("scrollBtn");
    const scrollBtnM = document.getElementById("scrollBtnM");
    const scrollTarget = document.getElementById("ourPhilosophy");

    scrollBtn.addEventListener("click", () => {
      scrollTarget.scrollIntoView({ behavior: "smooth" });
    });
    scrollBtnM.addEventListener("click", () => {
      scrollTarget.scrollIntoView({ behavior: "smooth" });
    });
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = '!function (e, t, i) { if (void 0 === e._dyntube_v1_init) { e._dyntube_v1_init = !0; var a = t.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = "https://embed.dyntube.com/v1.0/dyntube.js", t.getElementsByTagName("head")[0].appendChild(a) } }(window, document);  ';
    document.body.appendChild(s);
    document.querySelector("body").scrollTo(0, 0);
    getTop3Testdata({});
    getTopVideosHome({});
    fetchBlogsData({ limit: 8 });
    getDashboardData();
    // allCategories();
  }, []);

  useEffect(() => {
    function handlePlayerReady() {
      var player = dyntube.getPlayer("51v8eyn640z7a8IbyDong");
      player.muted(true);
      player.play();
      console.log("player addedd");
    }
    window.addEventListener("dyntubeReady", handlePlayerReady);
    return () => {
      window.removeEventListener("dyntubeReady", handlePlayerReady);
    };
  }, []);

  const handleCategoryWiseVideos = (item) => {
    setSelectedCategoryId(item.title);

    const videosAndCategories = topVideos?.sectionData?.videoInfo;

    setTimeout(() => {
      const videos = [];
      for (let i = 0; i < videosAndCategories?.length; i++) {
        if (item.title === videosAndCategories[i].title) {
          const catVideos = videosAndCategories[i].cards;
          for (let j = 0; j < catVideos?.length; j++) {
            videos.push(catVideos[j]);
          }
        }
      }
      setSelectedCategoryVideos(videos);
    }, 10);

    setTimeout(() => {
      const videos = [];
      for (let i = 0; i < videosAndCategories?.length; i++) {
        if (item.title === videosAndCategories[i].title) {
          const catVideos = videosAndCategories[i].cards;
          for (let j = 0; j < catVideos?.length; j++) {
            videos.push(catVideos[j]);
          }
        }
      }
      setSelectedCategoryVideos(videos);
    }, 10);
  };

  const [playBtn, setPlayBtn] = useState(1);
  let blogData;
  let blogSearch;
  if (blogsData?.data?.sectionData?.categoryAndfilter?.blogs?.length > 0 && blogsData?.data?.sectionData?.categoryAndfilter?.blogs[0].itemList.length > 0) {
    blogData = blogsData?.data?.sectionData?.categoryAndfilter?.blogs[0].itemList;
    blogSearch = blogsData?.data?.sectionData?.search;
  }

  const data = (
    <p>
      {parseHtml(TopData.length && TopData[0].desc)}
      {/* <span className="o">You</span> again. */}
    </p>
  );

  const philosophy = (
    <p className="wow fadeInRight" data-wow-delay="0.2s">
      {PhilosphyData[0] && PhilosphyData[0].desc}
    </p>
  );

  const category = (
    <>
      <div className="col-12 col-md-12 order-md-2 mt-7">
        <div className="row justify-content-center categoryBlock">
          <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
            <article className="philoBlock msColumn position-relative bg-border rounded-lg pt-8 pb-1 px-6 w-100 mb-13 wow fadeInUp" data-wow-delay=".3s">
              <span className="rounded-circle d-flex align-items-center text-center wow bounceIn" data-wow-delay=".4s">
                <span className="w-100 pb-4">
                  <img className="img-fluid" src={Hope} alt="Icon" />
                </span>
              </span>
              <h3 className="h5 fwMedium position-relative text-center">{PhilosphyData[0] && PhilosphyData[0].category[0].type}</h3>
              <p className="">{parseHtml(PhilosphyData[0] && PhilosphyData[0].category[0].desc)}</p>
            </article>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
            <article className="philoBlock msColumn position-relative bg-border rounded-lg pt-8 pb-1 px-6 w-100 mb-13 wow fadeInUp" data-wow-delay=".4s">
              <span className="rounded-circle d-flex align-items-center text-center wow bounceIn" data-wow-delay=".5s">
                <span className="w-100 pb-4">
                  <img className="img-fluid" src={Happiness} alt="Icon" />
                </span>
              </span>
              <h3 className="h5 fwMedium position-relative text-center">{PhilosphyData[0] && PhilosphyData[0].category[1].type}</h3>
              <p className="">{parseHtml(PhilosphyData[0] && PhilosphyData[0].category[1].desc)}</p>
            </article>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
            <article className="philoBlock msColumn position-relative bg-border rounded-lg pt-8 pb-1 px-6 w-100 mb-13 wow fadeInUp" data-wow-delay=".5s">
              <span className="rounded-circle d-flex align-items-center text-center wow bounceIn" data-wow-delay=".6s">
                <span className="w-100 pb-4">
                  <img className="img-fluid" src={Health} alt="Icon" />
                </span>
              </span>
              <h3 className="h5 fwMedium position-relative text-center">{PhilosphyData[0] && PhilosphyData[0].category[2].type}</h3>
              <p className="">{parseHtml(PhilosphyData[0] && PhilosphyData[0].category[2].desc)}</p>
            </article>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
            <article className="philoBlock msColumn position-relative bg-border rounded-lg pt-8 pb-1 px-6 w-100 mb-13 wow fadeInUp" data-wow-delay=".6s">
              <span className="rounded-circle d-flex align-items-center text-center wow bounceIn" data-wow-delay=".7s">
                <span className="w-100 pb-4">
                  <img className="img-fluid" src={Aspiration} alt="Icon" />
                </span>
              </span>
              <h3 className="h5 fwMedium position-relative text-center">{PhilosphyData[0] && PhilosphyData[0].category[3].type}</h3>
              <p className="">{parseHtml(PhilosphyData[0] && PhilosphyData[0].category[3].desc)}</p>
            </article>
          </div>
        </div>
      </div>
    </>
  );

  const offer = (
    <div className="wow fadeIn weOfferBullet" data-wow-delay="0.1s">
      {parseHtml(offerData[0] && offerData[0].description)}
    </div>
  );

  const Happyness = (
    <article id="happinessLife" className="happinessLife bg_test">
      <img src={first_slide_video} alt="first-slide" className="bgOpacity3 left rotate90 top0" />
      <img src={first_slide_video} alt="first-slide" className="bgOpacity3 right rotate90" />
      <div className="container position-relative">
        <div className="col-12 col-md-7">
          <header className="textSizeMedium">
            <h2 className="wow fadeInUp" data-wow-delay="0.1s">
              {parseHtml(staticData?.happinesSection?.title)}
            </h2>
            <p className="wow fadeInUp" data-wow-delay="0.2s">
              <strong className="fwMedium">{happinessData[0] && parseHtml(happinessData[0].description)}</strong>
            </p>
          </header>
          <div className="row text-center justify-content-center width80per">
            {happinessData[0] &&
              happinessData[0]?.type &&
              happinessData[0]?.type.map((elm, index) => {
                return (
                  <div className="col-6 col-sm-6 col-md-6" key={index}>
                    <aside className="text-white text-center pfbColumn position-relative w-100 rounded-lg wow fadeInUp" data-wow-delay=".3s">
                      {/* <i className="icomoon-telephone position-absolute bg-warning rounded-circle d-flex align-items-center justify-content-center icn wow bounceIn" data-wow-delay="1.5s"><span className="sr-only">icon</span></i> */}
                      <span>
                        <strong className="title text-uppercase fwMedium d-block mb-1">{elm.title}</strong>
                        {elm.desc ? (
                          <strong className="summary d-block font-weight-normal">
                            <p>{parseHtml(elm.desc)}</p>
                          </strong>
                        ) : (
                          ""
                        )}
                      </span>
                    </aside>
                  </div>
                );
              })}
          </div>
          <div className="happyImage wow fadeInUp" data-wow-delay=".3s">
            <img className="m_none" src={happyImage} alt="happy" />
            <img className="d_none" src={happy_mobile} alt="happy" />
          </div>
        </div>
        <div className="col-12 col-md-5"></div>
      </div>
    </article>
  );

  const [playing, setPlaying] = useState(true);
  const [secondPlaying, setSecondPlayingg] = useState(true);

  const [playerModal, setPlayerModal] = useState(false);
  const [playerSecondModal, setPlayerSecondModal] = useState(false);

  function handleClick() {
    setPlayBtn(0);
  }

  const handleVideo = (e) => {
    console.log("video hit");
    setPlayerModal(true);
    setIsLoader(true);
    window.addEventListener("dyntubeReady", () => {
      setIsLoader(false);
      var player = dyntube.getPlayer("51v8eyn640z7a8IbyDong");
      player.muted(false);
      player.play();
    });
  };

  const handleSecondVideo = (e) => {
    setPlayerSecondModal(true);
    setIsLoader(true);
    window.addEventListener("dyntubeReady", () => {
      setIsLoader(false);
      var player = dyntube.getPlayer("lBpB657e8keGj4nCuWpxA");
      player.play();
    });
  };

  const onLoadingVideoHandler = () => {
    setTimeout(() => setShowLoading(false), 500);
  };

  const handleSecondCancel = () => {
    setSecondPlayingg(false);
    pauseVideo();
    setTimeout(() => setPlayerSecondModal(false), 500);
    setPlayBtn(1);
  };

  const handleCancel = () => {
    setPlaying(false);
    pauseVideo();
    setTimeout(() => setPlayerModal(false), 500);
    setPlayBtn(1);
  };

  const pauseVideo = () => {
    var iframes = document.querySelectorAll("iframe");
    for (let i = 0; i < iframes.length; i++) {
      if (iframes[i] !== null) {
        var temp = iframes[i].src;
        iframes[i].src = temp;
      }
    }
  };

  const soltionDesc = <p>{soluionData?.[0]?.description}</p>;

  const renderLoginPopup = () => {
    return (
      <Modal className="w-100" centered open={true} onCancel={() => showPopup(null)} footer={null}>
        <Login />
      </Modal>
    );
  };

  const top3TestDets = () => {
    const top3Test = testData.slice(0, 5);
    return (
      <article className="testimonialsBlock position-relative">
        <img src={testimonial_bg} alt="testimonial" className="testimonialbg left darkno" />
        {/* <img src={testimonial_bg_dark} alt="" className="testimonialbg left darkYes" /> */}
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12">
              <header className="mb-7 mb-md-10 mb-xl-16  text-center">
                <h2 className="text-capitalize text-center wow" data-wow-delay="0.1s">
                  <strong className="fwMedium d-block position-relative text-capitalize mb-4 wow fadeInLeft">{parseHtml(staticData?.sachSsection?.title.replace("__SACH_ICON__", sachIcon))}</strong>
                </h2>
                <p className="fadeInLeft wow" data-wow-delay="0.3s">
                  {parseHtml(staticData?.sachSsection?.content)}
                </p>
              </header>
            </div>
            <div className="col-12 col-md-12">
              <div className="wow fadeInRight" data-wow-delay=".5s">
                <img src={quote_icon} alt="quote-icon" className="testimonialSlidebg left" />

                <div className="quotesSlider">
                  {top3Test.length > 0 && (
                    // <OwlCarousel className="owl-theme" id="sachCommunity" {...sachCommunity}>
                    <Swiper
                      slidesPerView={3}
                      spaceBetween={20}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      centeredSlides={true}
                      loop={true}
                      modules={[Autoplay, Pagination, Navigation]}
                      navigation={true}
                      pagination={{
                        clickable: true,
                      }}
                      height={"auto"}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                        600: {
                          slidesPerView: 2,
                        },
                        1000: {
                          slidesPerView: 3,
                        },
                      }}
                      id="sachCommunity"
                      className="mySwiper"
                    >
                      {top3Test.map((testimoni, j) => {
                        return (
                          <SwiperSlide key={j}>
                            <div className="item">
                              <div className="testiBlcok">
                                {testimoni.descriptionPlain.length > 0 ? (
                                  <p>
                                    <img src={quote_shape} alt="quote_shape" className="quote" />
                                    <Link to={UserRoutes.USER_TESTIMONIALS}>{parseHtml(testimoni.descriptionPlain.substring(0, 80))}</Link>
                                  </p>
                                ) : (
                                  <p>
                                    <img src={quote_shape} alt="quote_shape" className="quote" /> {parseHtml(testimoni.descriptionPlain)}
                                  </p>
                                )}
                                <div className="testimInfo">
                                  <img src={testimoni.authorImg} alt="icon" />
                                  <span>{testimoni.author}</span>
                                  <i>{testimoni.designation}</i>
                                </div>
                                {/* {top3Test[0].descriptionPlain.length > 120 ? (
                            <p>
                              <img src={quote_shape} alt="quote" className="quote" />
                              <Link to={UserRoutes.USER_TESTIMONIALS}>
                                 {parseHtml(
                                  top3Test[0].descriptionPlain.substring(0, 120)
                                )}
                              </Link>
                            </p>
                          ) : (
                            <p><img src={quote_shape} alt="quote" className="quote" /> {parseHtml(top3Test[0].descriptionPlain)}</p>
                          )} */}
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                      {/* {top3Test[1] && (
                      <div className="item">
                        <div className="testiBlcok">
                          {top3Test[1].descriptionPlain.length > 120 ? (
                            <p>
                              <img src={quote_shape} alt="quote" className="quote" /> 
                              <Link to={UserRoutes.USER_TESTIMONIALS}>
                              {parseHtml(
                                  top3Test[1].descriptionPlain.substring(0, 120)
                                )}
                              </Link>
                            </p>
                          ) : (
                            <p><img src={quote_shape} alt="quote" className="quote" /> {parseHtml(top3Test[1].descriptionPlain)}</p>
                          )}
                          <div className="testimInfo">
                            <img src={top3Test[1].authorImg} alt="icon" />
                            <span>{top3Test[1].author}</span>
                            <i>{top3Test[1].designation}</i>
                          </div>
                        </div>
                      </div>
                    )}
                    {top3Test[2] && (
                      <div className="item">
                        <div className="testiBlcok">
                          {top3Test[2].descriptionPlain.length > 120 ? (
                            <p>
                              <img src={quote_shape} alt="quote" className="quote" />
                              <Link to={UserRoutes.USER_TESTIMONIALS}>
                               {parseHtml(
                                  top3Test[2].descriptionPlain.substring(0, 120)
                                )}
                              </Link>
                            </p>
                          ) : (
                            <p> <img src={quote_shape} alt="quote" className="quote" /> {parseHtml(top3Test[2].descriptionPlain)}</p>
                          )}
                          <div className="testimInfo">
                            <img src={top3Test[2].authorImg} alt="icon" />
                            <span>{top3Test[2].author}</span>
                            <i>{top3Test[2].designation}</i>
                          </div>
                        </div>
                      </div>
                    )}
                    {top3Test[3] && (
                      <div className="item">
                        <div className="testiBlcok">
                          {top3Test[3].descriptionPlain.length > 120 ? (
                            <p>
                              <img src={quote_shape} alt="quote" className="quote" />
                              <Link to={UserRoutes.USER_TESTIMONIALS}>
                               {parseHtml(
                                  top3Test[3].descriptionPlain.substring(0, 120)
                                )}
                              </Link>
                            </p>
                          ) : (
                            <p> <img src={quote_shape} alt="quote" className="quote" /> {parseHtml(top3Test[3].descriptionPlain)}</p>
                          )}
                          <div className="testimInfo">
                            <img src={top3Test[3].authorImg} alt="icon" />
                            <span>{top3Test[3].author}</span>
                            <i>{top3Test[3].designation}</i>
                          </div>
                        </div>
                      </div>
                    )}
                    {top3Test[4] && (
                      <div className="item">
                        <div className="testiBlcok">
                          {top3Test[4].descriptionPlain.length > 120 ? (
                            <p>
                              <img src={quote_shape} alt="quote" className="quote" />
                              <Link to={UserRoutes.USER_TESTIMONIALS}>
                               {parseHtml(
                                  top3Test[4].descriptionPlain.substring(0, 120)
                                )}
                              </Link>
                            </p>
                          ) : (
                            <p> <img src={quote_shape} alt="quote" className="quote" /> {parseHtml(top3Test[4].descriptionPlain)}</p>
                          )}
                          <div className="testimInfo">
                            <img src={top3Test[4].authorImg} alt="icon" />
                            <span>{top3Test[4].author}</span>
                            <i>{top3Test[4].designation}</i>
                          </div>
                        </div>
                      </div>
                    )} */}
                    </Swiper>
                  )}
                </div>
                <div className="col-lg-12 text-center">
                  <Link
                    to={UserRoutes.USER_TESTIMONIALS}
                    // onClick={() => handleViewMoreClick(category)}
                    className="btn btn-sach bg-sach-dark"
                  >
                    {staticData?.testimonialSection?.cta?.text}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    );
  };

  return (
    <>
      <article className="w-100 d-flex mobileDisble" id="homeVideo">
        <div
          dangerouslySetInnerHTML={{
            __html: `<video id="video_background" loop controls autoplay muted>
          <source
            src="https://turbine-project.s3.ap-south-1.amazonaws.com/sach/v5/images/Zee-dub-match-preview.mp4"
            type="video/mp4"
          />
        </video>`,
          }}
        />

        {playerModal && (
          <Modal
            centered
            closable={true}
            onCancel={handleCancel}
            visible={true}
            footer={null}
            // height={100}
            width={1200}
            layout="responsive"
            className="home-hero-video"
          >
            {isLoader && (
              <div className="row">
                <div className="col-12 text-center position-relative">
                  <video className="w-100">
                    poster={video_image_homePage}
                    <source src="../media/banner.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            )}
            <div data-dyntube-key="51v8eyn640z7a8IbyDong"></div>
          </Modal>
        )}

        <div className="videoIntro">
          {window.outerWidth > 768 && (
            <h1 className="toph1 wow fwMedium f-800 fadeInLeft" data-wow-delay="0.1s">
              {parseHtml(staticData?.topSection?.title)}
            </h1>
          )}
          <div className="col-lg-12 wow fadeInLeft watchLink" data-wow-delay=".2s">
            <span data-toggle="modal" data-target=".bd-example-modal-lg" className="btn" onClick={(e) => handleVideo(e)}>
              {parseHtml(staticData?.topSection?.watchFullVideo)}
              <img src={video_play_icon} alt="play-icon" />
            </span>
          </div>
        </div>
        <div className="scrollDown" id="scrollBtn">
          <p>{parseHtml(staticData?.topSection?.exploreMore)}</p>
          <div className="indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </article>

      <article className="introBlock w-100 d-flex mobileEnable position-relative">
        <div className="mainsc_content text-center">
          <img src={homeBgMobile} alt="mobile_top" className="topbgMobile" />
          {window.outerWidth <= 768 && (
            <h1 className="wow fwMedium f-800 fadeInLeft" data-wow-delay="0.2s">
              Get <span className="o"> Hope,</span> <span className="o"> Happiness,</span>
              <br />
              <span className="o">Health,</span> and <span className="o"> Aspiration</span> in Life
            </h1>
          )}

          <div data-toggle="modal" data-target=".bd-example-modal-lg" className="btn" onClick={(e) => handleVideo(e)}>
            <img className="play_icon" data-toggle="modal" data-target=".bd-example-modal-lg" src={play_icon} alt="play-icon" />
          </div>
        </div>

        <div className="scrollDown" id="scrollBtnM">
          <p>Explore More</p>
          <div className="indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </article>

      {/* <OurPhilosphy philosophySection={staticData?.philosophySection} dashboardData={dashboardData?.homePageData?.PhilosphyData} /> */}
      <article id="ourPhilosophy" className="philosophyBlock bg-white">
        <img src={first_slide_video} alt="first-slide" className="bgOpacity3 left" />
        <img src={first_slide_video} alt="first-slide" className="bgOpacity3 right" />
        {/* <img src="images/shapes_dark/white-pattern.png" alt="" className="bgOpacity3 left darkYes">
				<img src="images/shapes_dark/white-pattern.png" alt="" className="bgOpacity3 right darkYes"> */}

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 order-md-1">
              <header className="mb-lg-5 text-center">
                <h2 className="text-capitalize mb-4 mb-lg-4 wow fadeInRight" data-wow-delay="0.1s">
                  <strong className="fwMedium d-block text-capitalize mb-3 wow fadeInRight">{staticData?.philosophySection?.title}</strong>
                  {parseHtml(staticData?.philosophySection?.subTitle)}
                </h2>
                {philosophy}
              </header>
            </div>
            {category}
          </div>
        </div>
      </article>

      <article className="whatWeOffer bg-white position-relative">
        <img src={triangle_white_pattern} alt="triangle-white-pattern" className="happyLifebg left top0" />
        <img src={circle_white_pattern} alt="circle-white-pattern" className="happyLifebg right" />
        <div id="journey" className="mt-n43 pt-43 alignDivCenter">
          <div className="container">
            <header className="text-center mb-8">
              <h2 className="text-capitalize position-relative">
                <span className="d-block wow fadeIn" data-wow-delay="0.1s">
                  {staticData?.offerSection?.title} <img src={sach_small_white} alt="logo" />
                </span>
              </h2>
              <h5 className="text-white">{offer}</h5>
            </header>
            <div className="row align-items-md-center">
              <div className="col-12 col-md-6">
                <div className="extraWrap pl-5 pl-xl-0 ml-xl-n4">
                  <ul className="list-unstyled eventCounsling position-relative pt-8 mb-0">
                    <li>
                      <div className="elStoryColumn position-relative wow fadeIn" data-wow-delay=".2s">
                        <span className="escIcnWrap d-flex align-items-center justify-content-center text-center rounded-circle position-absolute">
                          <span className="w-100 d-block">01</span>
                        </span>
                        <div className="descrWrap">
                          <strong className="prTitle font-weight-normal d-block">{parseHtml(staticData?.counsellingSection?.title)}</strong>
                          <p>{parseHtml(checkAuthentication() ? staticData?.counsellingSection?.subTitle : staticData?.counsellingSection?.subTitle?.replace("mailto:yoursarthi@sach.org.in", "https://sach.org.in/login"))}</p>
                          <p>{parseHtml(staticData?.counsellingSection?.content)}</p>
                          <p>
                            <Link to={UserRoutes.COUNSELING} className="f-600">
                              {staticData?.counsellingSection?.cta?.text} <img src={we_offer_icon} alt="we-offer" />
                              {/* <i className="bi bi-arrow-right"></i> */}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="elStoryColumn position-relative wow fadeIn" data-wow-delay=".3s">
                        <span className="escIcnWrap d-flex align-items-center justify-content-center text-center rounded-circle position-absolute">
                          <span className="w-100 d-block">02</span>
                        </span>
                        <div className="descrWrap">
                          <strong className="prTitle font-weight-normal d-block">{parseHtml(staticData?.eventSection?.title)}</strong>
                          {/* <p>{eventData[0] && eventData[0].title}</p> */}
                          <p>{eventData[0] && eventData[0].description}</p>
                          <p>
                            <Link to={UserRoutes.USER_EVENT} className="f-600">
                              {staticData?.eventSection?.cta?.text} <img src={we_offer_icon} alt="we-offer" />
                              {/* <i className="bi bi-arrow-right"></i> */}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="elStoryColumn position-relative wow fadeIn" data-wow-delay=".3s">
                        <span className="escIcnWrap d-flex align-items-center justify-content-center text-center rounded-circle position-absolute">
                          <span className="w-100 d-block">03</span>
                        </span>
                        <div className="descrWrap">
                          <strong className="prTitle font-weight-normal d-block">{parseHtml(videoSectionData?.title)}</strong>
                          {/* <h3 className="escHeading font-weight-normal mb-4">{videoSectionData[0] && videoSectionData[0].title}:</h3> */}
                          <p>{videoSectionData && videoSectionData.content}</p>
                          <p>
                            <Link to={UserRoutes.CATEGORY_HOME_PAGE} className="f-600">
                              {videoSectionData?.cta?.text} <img src={we_offer_icon} alt="we-offer" />
                              {/* <i className="bi bi-arrow-right"></i> */}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mx-auto text-right mx-md-0 rounded overflow-hidden mt-md-n4 mb-4 mb-md-0 wow fadeInLeft" data-wow-delay="0.2s">
                  <div className="col-12">
                    <div className="videoBlock">
                      <img src={first_slide_video} alt="first-slide" className="firstSlideVideo" />
                      <div className="videocontainer">
                        <video width="550" height="310" onClick={() => handleSecondVideo()} poster={we_offer}>
                          {/* <source src="images/LIVE IN PRESENT.mp4" type="video/mp4" /> */}
                          {/* <source src="movie.ogg" type="video/ogg">  */}
                          Your browser does not support the video tag.
                        </video>
                        {playerSecondModal && (
                          <Modal centered closable={true} onCancel={handleSecondCancel} visible={true} footer={null} width={1100} className="home-hero-video">
                            {/* {isLoader && <div className="row mt-lg-5 mt-3">
                    <div className="col-12 text-center position-relative">
                        <video className="w-100 mt-2" poster={OfferImage}>
                          <source src="../media/movie.mp4" type="video/mp4" />
                        </video>
                        <img src={OfferImageThumb} className="img-fluid" alt="video-thumb" />
                      </div>
                    </div>} */}
                            {isLoader && (
                              <div className="row mt-lg-5 mt-3">
                                <div className="col-12 text-center position-relative">
                                  <video className="w-100 rounded" poster={OfferImageThumb}>
                                    <source src="../media/banner.mp4" type="video/mp4" />
                                  </video>
                                </div>
                              </div>
                            )}
                            <div data-dyntube-key="lBpB657e8keGj4nCuWpxA"></div>
                          </Modal>
                        )}

                        {/* <video className="w-100 mt-2" poster={OfferImage} onClick={() => handleSecondVideo()}>
                        
                      </video>
                      {playBtn && !playerSecondModal ? (
                        <div className="play-btn" onClick={(e) => handleSecondVideo(e)}>
                          <i className="bi bi-play-fill"></i>
                        </div>
                      ) : null} */}
                      </div>

                      <div className="autherName">
                        <img src={auther_name} alt="author" />
                      </div>
                    </div>
                    {/* <div className="play-btn">
                      <i className="bi bi-play-fill"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <article id="videoSection" className="videoSection">
        <img src={first_slide_video} alt="first-slide" className="bgOpacity3 left darkno" />
        <img src={first_slide_video} alt="first-slide" className="bgOpacity3 right rotate90 darkno" />
        {/* <img src="images/shapes_dark/white-pattern.png" alt="" className="bgOpacity3 left darkYes">
				<img src="images/shapes_dark/white-pattern.png" alt="" className="bgOpacity3 right rotate90 darkYes"> */}
        <div id="about" className="mt-n43 pt-43">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 order-md-1">
                <header className="mb-lg-5 text-center">
                  <h2 className="text-capitalize wow fadeInRight" data-wow-delay="0.1s">
                    <strong className="fwMedium d-block text-uppercase mb-3 wow fadeInRight">{parseHtml(staticData?.solutionSection?.ourVideos)}</strong>
                    {parseHtml(checkAuthentication() ? staticData?.solutionSection?.title : staticData?.solutionSection?.title?.replace("mailto:yoursarthi@sach.org.in", "https://sach.org.in/login"))}
                  </h2>
                </header>
              </div>
              <div className="col-12 col-md-12 order-md-2 mt-7">
                <div className="row justify-content-center wow fadeIn" data-wow-delay=".2s">
                  <div className="videoSlidersArea">
                    {/* <div className="tabs">
                      {selectedCategoryId && (
                        <Swiper slidesPerView={"auto"} spaceBetween={10} scrollbar={{ hide: true }} modules={[Scrollbar, Navigation]} navigation={true} className="mySwiper">
                          {allCategories().map((item) => {
                            return (
                              <SwiperSlide key={item.title}>
                                <div className="item wow fadeIn" data-wow-delay=".3s">
                                  <span onClick={() => handleCategoryWiseVideos(item)} className={selectedCategoryId === item.title ? "badge text-dark custom-badge rounded-pill active" : "badge text-dark custom-badge rounded-pill"} role="button">
                                    {item.title}
                                  </span>
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      )}
                    </div> */}
                    <div className="videoSectionHeading">
                      <div className="dscTab">DSC SHOW</div>
                      <div className="readMore">
                        <a href={UserRoutes.CATEGORY_HOME_PAGE}>View All</a>
                      </div>
                    </div>
                    <div className="videoContainer">
                      {selectedCategoryVideos.length > 0 && (
                        <Swiper
                          slidesPerView={3}
                          spaceBetween={10}
                          // autoplay={{
                          //   delay: 2500,
                          //   disableOnInteraction: false,
                          // }}
                          modules={[Autoplay, Pagination, Navigation]}
                          navigation={true}
                          pagination={{
                            clickable: true,
                          }}
                          breakpoints={{
                            0: {
                              slidesPerView: 1,
                            },
                            600: {
                              slidesPerView: 2,
                            },
                            1000: {
                              slidesPerView: 3,
                            },
                          }}
                          className="mySwiper"
                        >
                          {/* <OwlCarousel className="owl-carousel owl-theme" id="solutionsVideos" {...solutionsVideos}> */}
                          {selectedCategoryVideos.map((vid, i) => {
                            return (
                              <SwiperSlide key={i}>
                                <div
                                  className="item"
                                  onClick={() => {
                                    navigate(UserRoutes.CATEGORY_VIDEO_PAGE + "?catId=" + vid.categoryId + "&subCatId=" + vid.subCategoryId + "&videoId=" + vid.videoId);
                                  }}
                                >
                                  <div className="videoBlock">
                                    <div className="videocontainer">
                                      <img src={vid.icon} alt="video-thumb" />
                                      {/* <img src="images/videolistImg.jpg" alt=""> */}
                                    </div>
                                    <div className="timeInterval">{vid.duration}</div>
                                    <div className="descblcok">
                                      <h3>{vid.title}</h3>
                                      <p>{vid.title}</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      {Happyness}

      {/* {showTop3Test && top3TestDets()} */}
      <TestimonialBlock testData={props.testData} testMeta={staticData?.sachSsection} action={dashboardData?.testimonialSection} />

      <article className="aboutBlock howBlock position-relative">
        <img src={triangle_shape} alt="icon" className="triangleShape left top0" />
        <img src={circle_shape} alt="icon" className="circleShape right rotate90" />

        {/* <img src="images/shapes_dark/triangle-shape.png" alt="" className="triangleShape left top0 darkYes">
						<img src="images/shapes_dark/circle-shape.png" alt="" className="circleShape right rotate90 darkYes">  */}
        <div id="about" className="mt-n43 pt-43">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 order-md-1 alignDivCenter justify-content">
                <header className="text-center ">
                  <h2 className="text-capitalize mb-4 mb-lg-7 wow fadeInRight" data-wow-delay="0.1s">
                    {parseHtml(staticData?.helpSection?.title.replace("__SACH_ICON__", sachIcon))}
                  </h2>
                  {parseHtml(staticData?.helpSection?.content)}
                </header>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article id="aboutGuru" className="aboutGuru bg-white">
        <div id="about" className="mt-n43 pt-43">
          <div className="container alignDivCenter justify-content">
            <div className="row">
              <div className="col-12 col-md-12 order-md-1"></div>
              <div className="col-12 col-md-12 order-md-2 mt-7">
                <div className="row">
                  <header className="text-center" style={{ flex: "0 0 100%" }}>
                    <h2 className="text-capitalize mb-4 mb-lg-7 wow fadeInRight" data-wow-delay="0.3s">
                      {parseHtml(staticData?.guruSection?.title)}
                    </h2>
                  </header>
                </div>
                <div className="row justify-content-center inspiration">
                  <div className="sub position-relative">
                    <ul className="guruList">
                      <li className="wow fadeIn" data-wow-delay=".5s">
                        <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/homepage/guru-01.png" alt="guru" />

                        <label>{parseHtml(staticData?.guruSection?.gurusDetails?.lateJaganNathGoenka)}</label>
                      </li>
                      <li className="wow fadeIn" data-wow-delay=".7s">
                        <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/homepage/guru-02.png" alt="guru" />
                        <label>{parseHtml(staticData?.guruSection?.gurusDetails?.lateSNGoenka)}</label>
                      </li>
                      <li className="wow fadeIn" data-wow-delay=".9s">
                        <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/homepage/guru-03.png" alt="guru" />

                        <label>{parseHtml(staticData?.guruSection?.gurusDetails?.gurus)}</label>
                      </li>
                    </ul>
                    <img className="downArrow" src={down_arrow} alt="down_arrow" />
                  </div>
                  <div className="main wow fadeIn position-relative" data-wow-delay="1.1s">
                    <div className="mainDesc">
                      {/* {parseHtml(staticData?.guruSection?.gurusDetails?.subhashChandra)} */}
                      {/* {parseHtml(staticData?.guruSection?.gurusDetails?.subhashChandraText)} */}
                      <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/homepage/guru-04.png" alt="guru" />
                      <label>
                        {parseHtml(staticData?.guruSection?.gurusDetails?.subhashChandra)}
                        <br />
                        {parseHtml(staticData?.guruSection?.gurusDetails?.subhashChandraText)}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <article id="blogBlock" className="blogBlock">
        <div className="mt-n43 pt-43">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 order-md-1">
                <header className="mb-lg-5 text-center">
                  <h2 className="text-capitalize mb-4 mb-lg-4 wow fadeInRight" data-wow-delay="0.5s">
                    {staticData && staticData.blogSection && staticData.blogSection.title}
                  </h2>
                  <p>{parseHtml(checkAuthentication() ? staticData && staticData.blogSection && staticData.blogSection.content?.replace("https://sach.org.in/login", "https://sach.org.in/write-blog") : staticData && staticData.blogSection && staticData.blogSection.content)}</p>
                </header>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-12">
                <div className="blogSliders">
                  {/* <OwlCarousel className="owl-theme" id="sachCommunityBlog" {...sachCommunityBlog}> */}
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    loop={true}
                    modules={[Pagination, Navigation]}
                    navigation={true}
                    pagination={{
                      clickable: true,
                    }}
                    // autoplay={{
                    //   delay: 2500,
                    //   disableOnInteraction: false,
                    // }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      600: {
                        slidesPerView: 2,
                      },
                      1000: {
                        slidesPerView: 3,
                      },
                      1280: {
                        slidesPerView: 4,
                      },
                    }}
                    className="mySwiper"
                  >
                    {blogData &&
                      blogData?.map((blog, index) => (
                        <SwiperSlide key={index}>
                          <div
                            className="item"
                            onClick={() => {
                              navigate(UserRoutes.BLOG_DETAIL + "?id=" + blog?.blogId);
                            }}
                          >
                            <div className="blogContainer">
                              <div className="blog-thumb">
                                <img src={blog?.blogThumnail} alt="Blog" className="img-fluid" />
                              </div>
                              <div className="content">
                                <div className="eventInfo">
                                  <label>{blog?.tags?.[0]}</label>
                                </div>
                                {index === 0 ? <div className="title">{blog?.title.length > 45 ? `${blog?.title.substring(0, 45)}...` : blog?.title}</div> : <div className="title">{blog?.title.length > 45 ? `${blog?.title.substring(0, 45)}...` : blog?.title}</div>}

                                <div className="blogshort">{parseHtml(blog?.desc)}</div>
                                <div className="eventInfoUser">
                                  <label>
                                    <span className="profile">
                                      {/* <em>TS</em> */}
                                      by{" "}
                                    </span>
                                    {blog?.author}
                                  </label>{" "}
                                  <em className="dot"></em>
                                  <span className="date">{blog?.date}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
              <div className="col-lg-12 text-center">
                <button className="btn btn-sach bg-sach-dark" onClick={() => navigate(UserRoutes.USER_BLOGS)}>
                  {staticData?.testimonialSection?.cta?.text}
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* <Subcriber newsSection={staticData?.newsLetterSection} /> */}

      <Outlet />
      {commonData?.popupType != "" && commonData?.popupType === "login" && renderLoginPopup()}
    </>
  );
};

const mapStateToProps = (state) => {
  const { CommonReducer } = state;
  const { commonData, params = {}, testData = [], showTop3Test = false, topVideos = {}, dashboardData = {} } = CommonReducer;
  return {
    ...state,
    ...params,
    commonData: commonData,
    testData,
    showTop3Test,
    topVideos,
    blogsData: state?.BlogReducer,
    dashboardData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showPopup: (type, data) => dispatch(showPopup(type, data)),
    getTop3Testdata: (params) => dispatch(getTop3Testdata(params)),
    getTopVideosHome: (params) => dispatch(getTopVideosHome(params)),
    fetchBlogsData: (data) => dispatch(fetchBlogsData(data)),
    getDashboardData: () => dispatch(getDashboardData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
